
import React from "react";
import SsoButtons from "../components/SsoButtons.js";

export default class LinkAccount extends React.Component {

  /**
   * Initializes the LinkAccount component.
   * @param {Object} props - React props.
   */
  constructor(props) {
    super(props);
    this.state = {};
  }


  /**
   * React lifecycle method.
   * Called after the component is mounted.
   * THIS IS EMPTY, WHY IS IT HERE?!
   */
  componentDidMount = () => {
  };

  /**
  * Closes the LinkAccount dialog by calling the close prop.
  */
  closeMe = () => {
    this.props.close(false);
  };

  /**
    * Renders the LinkAccount dialog.
    * Displays a message and SSO buttons for linking accounts.
    * @returns {JSX.Element}
    */
  render() {
    return (
      <div className="LinkAccount floating-dialog">
        <div className="close" onClick={() => this.props.close(false)}><i className="fa fa-times-circle"></i></div>
        <div className="me-4">
          <h3 className="m-2">Here you can link your Google or Microsoft account to make logging in much easier.</h3>
        </div>
        <SsoButtons type="link" close={this.closeMe} />
      </div>
    );
  }
}
